import { useState } from "react";
import NxtbnDrawer from "../../drawer";
import { InputField, NXForm } from "../../common";
import { toast } from "react-toastify";
import useApi from "../../../api";

interface Props {
    edit?: any;
    isOpen: boolean;
    onClose: ()=>void;
    refresh: ()=>void;
}

function WarehouseForm({edit, isOpen, onClose, refresh }:Props) {
  const api = useApi()

  const [formData, setFormData] = useState<any>(edit ? {
    id: edit.node.dbId,
    name: edit.node.name,
    location: edit.node.location,
    is_default: edit.node.isDefault
  } : {})
  const [errorData, setErrorData] = useState<any>()

  const onChangeInput = (e:any) => {
    const { name, value } = e.target
    setFormData((prev:any)=>({...prev, [name]: value}))
  }



  const onSubmit = (e:any, id?:number) => {
    e.preventDefault()
    if (!edit) { 
      api.createWarehouse(formData).then((response:any)=>{
        toast.success("Tax class created")
        onClose()
        refresh()
        setFormData({})
      }, (error)=>setErrorData(error.response.data))
    } else {
      api.updateWarehouse(id, formData).then((response:any)=>{
        toast.success('Successfully updated tax class.')
        onClose()
        refresh()
        setFormData({})
      }, (error)=>setErrorData(error.response.data))
    }
  }
  return (
    <NxtbnDrawer
      isOpen={isOpen}
      onClose={onClose}
      title={edit ? "Update Warehouse": "Create Warehouse"}
    >
      <div className="p-4 h-[85vh] ">

        <NXForm 
            className="h-full overflow-y-auto py-4 px-2 my-2"
            onSubmit={onSubmit}
            title={edit ? "Edit Warehouse" : "Create Warehouse"}
        >
          <div className="flex flex-col w-full pt-6">
            <label htmlFor="name" className="text-sm text-base-300">
              Name
            </label>
            <div>
              <InputField
                id="name"
                type="text"
                name="name"
                value={formData?.name || ""}
                onChange={onChangeInput}
                placeholder="Enter tax class name"
                className="w-full px-5 py-3 bg-secondary-50 mt-3 rounded-md font-nunito outline-[#0CAF60] border-[2px] border-dashed"
                errorData={errorData}
              />
            </div>
          </div>
          <div className="flex flex-col w-full pt-6">
            <label htmlFor="location" className="text-sm text-base-300">
              Location
            </label>
            <div>
              <InputField
                id="location"
                type="text"
                name="location"
                value={formData?.location || ""}
                onChange={onChangeInput}
                placeholder="Enter tax class name"
                className="w-full px-5 py-3 bg-secondary-50 mt-3 rounded-md font-nunito outline-[#0CAF60] border-[2px] border-dashed"
                errorData={errorData}
              />
            </div>
          </div>

          <div className="flex flex-col w-full pt-6">
              <label htmlFor="description" className="text-sm text-base-300">
                Default (Only one default warehouse is allowed)
              </label>
              <input type="checkbox" name="is_default" onChange={onChangeInput}></input>
          </div>

          <div className="mt-6 mb-6 flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="mr-3 inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-gray-600 text-base font-medium text-white shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-primary-600 text-base font-medium text-white shadow-sm hover:bg-primary-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
              onClick={(e: any) =>
                edit ? onSubmit(e, formData.id) : onSubmit(e)
              }
            >
              {edit ? "Update" : "Add"}
            </button>
          </div>
        </NXForm>
      </div>
    </NxtbnDrawer>
  );
}

export default WarehouseForm;
